/* eslint-disable @typescript-eslint/no-explicit-any */
// Styles for RoomsandGuests go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledRoomsAndGuests = styled.div<{
  $isNextGenHP?: boolean;
  $buttonOffset?: number;
}>`
  cursor: default;

  &.rooms-and-guests {
    button {
      ${props =>
        props.$isNextGenHP &&
        `
        @media ${baseVariables.mediaQuery.lg} {
          padding-right: 0 !important;
          padding-left: 0 !important;
        }
      `};
    }
  }

  /* NextGen standard: is-active/is-inactive styling for desktop and mobile */
  .rooms-guests-input-wrapper {
    display: flex;
    align-items: center;
    width: auto;

    &.is-inactive {
      color: ${baseVariables.color.neutral40};
      font-weight: ${baseVariables.font['fontWeightRegular']};
      .rooms-guests-icon-wrapper {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        .icon-room-ready {
          font-size: ${toRem(20)};
          color: ${baseVariables.color.base10};
          line-height: ${toRem(20)};
        }
      }

      .m-input-text-field {
        margin-bottom: 0;
        flex: 0 0 auto;
        min-width: 0;

        label {
          display: none;
        }

        /**
         * IMPORTANT: These styles use !important to prevent being overridden by
         * @marriott/global-styles which gets dynamically loaded when the sign-in
         * modal opens. The global-styles contains a generic .m-input-text-field
         * input[type=text] selector that would otherwise override our custom styling.
         * See WEB-183120 for details.
         */
        input[type='text'].rooms-guests-input-field {
          border: none !important;
          padding: 0 0 0 ${toRem(8)} !important;
          line-height: 0 !important;
          font-size: ${toRem(14)} !important;
          font-weight: 500 !important;
          color: ${baseVariables.color.neutral40} !important;
          height: auto !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          width: var(--input-ch-width, auto);

          @media ${baseVariables.mediaQuery.lg} {
            font-size: ${toRem(16)} !important;
          }

          &.rooms-guests-m-font {
            padding-bottom: 0 !important;
          }
        }
      }

      /* Hide trailing icon in inactive state */
      .trailing-element {
        display: none;
      }
    }

    &.is-active {
      display: block;

      .rooms-guests-icon-wrapper {
        display: none;
      }

      .m-input-text-field {
        label {
          display: block;
        }

        /**
         * IMPORTANT: These styles use !important to prevent being overridden by
         * @marriott/global-styles. See comment above for details (WEB-183120).
         */
        input[type='text'].rooms-guests-input-field {
          font-size: ${toRem(16)} !important;
          font-weight: 700 !important;
          padding: ${toRem(26)} ${toRem(40)} ${toRem(10)} ${toRem(16)} !important;
          text-overflow: ellipsis;
        }
      }

      .trailing-element {
        display: flex;
      }
    }
  }

  // Add focus styling only when rooms & guests dropdown is actually open
  // Target when the component has both is-active class AND dropdown-open class
  &.is-active.dropdown-open
    .rooms-guests-input-wrapper.is-active
    .m-input-text-field
    input[type='text'].rooms-guests-input-field {
    border: ${toRem(1.5)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color.base10};
  }

  .m-dropdown-action-bar {
    position: fixed !important;
    bottom: ${toRem(-6)} !important;
    background: ${baseVariables.color['base20']} !important;
    padding-right: ${toRem(24)} !important;
    border-top: ${toRem(1)} solid ${baseVariables.color.neutral20} !important;
    padding-left: ${toRem(24)} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding-right: ${toRem(32)} !important;
      padding-left: ${toRem(32)} !important;
    }
  }
  @media ${baseVariables.mediaQuery.md} {
    .icon-clear {
      padding-right: ${toRem(8)};
    }
  }

  .m-dropdown-content {
    scrollbar-gutter: stable;

    &::-webkit-scrollbar {
      display: none;
      @media ${baseVariables.mediaQuery.lg} {
        display: block;
      }
    }
  }
  .dropdown-container {
    margin: 0 auto;
  }
  .m-input-text-field {
    label,
    input {
      cursor: pointer;
    }
  }
  .rooms-guests-m-font {
    font-weight: 500;
    padding-bottom: ${props => (!props.$isNextGenHP ? `${toRem(9)} !important` : 'inherit')};
  }
  .icon-arrow-down {
    &:before {
      line-height: ${props => (!props.$isNextGenHP ? `${toRem(16)}` : 'inherit')};
    }
  }
  .header-heading {
    height: ${props => (!props.$isNextGenHP ? `${toRem(28)}` : 'inherit')};
  }
  .t-font-s {
    height: ${props => (!props.$isNextGenHP ? `${toRem(21)}` : 'inherit')};
  }
  .m-stepper-desc {
    line-height: ${toRem(18)} !important;
    font-weight: ${baseVariables.font['fontWeightRegular']};
  }
  .m-link-action {
    display: inline-block;
    height: ${props => (!props.$isNextGenHP ? `${toRem(18)}` : 'inherit')};
    line-height: ${toRem(18)};
  }
  .m-stepper-wrapper .m-stepper > span {
    padding: 0;
  }
  .m-stepper-wrapper {
    padding: ${toRem(16)} 0;
    @media ${baseVariables.mediaQuery.lg} {
      padding: ${toRem(8)} 0;
    }
  }
  .m-dropdown-children {
    position: relative;
    padding: ${toRem(8)} ${toRem(0)} ${toRem(8.5)} ${toRem(0)};
    .stepper-text-contianer {
      border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
      .m-stepper-label {
        width: ${toRem(180)};
        text-wrap: wrap;
      }
    }
    .child-collection {
      .m-stepper-wrapper {
        padding: ${toRem(8)} 0;
        border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .m-icon-text {
    .progress-status {
      color: ${baseVariables.color['neutral40']};
    }
  }
  .m-dropdown-header {
    background: ${baseVariables.color['base20']};
    z-index: 1;
    position: sticky;
    top: 0;
    border-bottom: unset;
    padding: ${toRem(0)} ${toRem(0)} ${toRem(12)} ${toRem(0)};
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      top: ${toRem(66)};
      transform: translateX(-50%);
      width: 100%;
    }
  }

  .dropdown-to-modal {
    height: 80vh;
    overflow: scroll;
    position: fixed;
    max-height: 80vh;
    .child-collection {
      padding-bottom: ${toRem(80)};
    }
    .m-dropdown-content {
      max-height: calc(80vh - ${toRem(140)});
      padding: 0 !important;

      .m-dropdown-children {
        height: auto;
      }

      &::-webkit-scrollbar {
        width: ${props => (!props.$isNextGenHP ? '0' : 'inherit')};
      }
    }
  }

  @media ${baseVariables.mediaQuery.lg} {
    position: relative;
    .tabbed-form-dropdown-container {
      top: unset !important;
    }
    .dropdown-container {
      position: absolute;
      z-index: 1011;
      left: 0;
      padding-top: ${toRem(4)};
      &:before {
        background: none;
      }

      .dropdown-modal-content {
        height: fit-content;
        max-height: fit-content;
        padding: ${toRem(16)};
        width: ${toRem(348)};
      }

      & .m-dropdown-container {
        margin: 0 auto;
        height: fit-content;
        width: ${toRem(348)};
        top: 75%;
        border-radius: ${toRem(8)};
        overflow: visible;
      }
    }
    .m-dropdown-children {
      padding: 0;
      .child-collection {
        padding-bottom: 0;
        .m-stepper-wrapper {
          padding: ${toRem(8)} 0;
        }
      }
    }
  }
  .rooms-guests-dropdown-container {
    left: unset;
    right: 0;
  }

  /* NextGen standard: Left align dropdown in is-active mode */
  &.is-active .rooms-guests-dropdown-container {
    left: 0;
    right: unset;
  }
`;
